import React, { Component } from 'react';
import ProtectedComponent from '../components/ProtectedComponent';
import AuthenticatedHome from './AuthenticatedHome';
import UnauthenticatedHome from './UnauthenticatedHome';

function renderAlt() {
  return <UnauthenticatedHome />;
}

class HomePage extends Component {

  render() {

    return (
      <div className='home flex-element flex-container flex-justify-around'>
        <ProtectedComponent alternateComponent={ renderAlt }>
          <AuthenticatedHome />
        </ProtectedComponent>
      </div>
    );
  }

}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/HomePage.js